// Ponto único para abrir/fechar o overlay #loading-div (main.blade.php).
// Contador: requisições simultâneas mantêm o overlay até a última terminar.
// Nenhum outro arquivo deve tocar em #loading-div.

// ponytail: teto de 60s contra travamento; subir se algum processo legítimo passar disso.
const WATCHDOG_MS = 60000;

let count = 0;
let watchdog = null;

const render = () => $('#loading-div').css('display', count > 0 ? 'flex' : 'none');

const Loader = {
    show() {
        count++;
        clearTimeout(watchdog);
        watchdog = setTimeout(Loader.reset, WATCHDOG_MS);
        render();
    },

    hide() {
        count = Math.max(0, count - 1);
        if (count === 0) clearTimeout(watchdog);
        render();
    },

    reset() {
        count = 0;
        clearTimeout(watchdog);
        render();
    },

    // Abre o loader e garante o fechamento quando a promise resolver ou falhar.
    wrap(promise) {
        Loader.show();
        return promise.finally(Loader.hide);
    },
};

// Botão "Voltar": o bfcache restaura a página com o overlay como estava.
window.addEventListener('pageshow', (e) => e.persisted && Loader.reset());

window.Loader = Loader;

export default Loader;
